import React from 'react';
import PropTypes from 'prop-types';

export default function Avatar({
  imageUrl = '',
  width = 150,
  height = 150,
  borderRadius = 50,
  style = {},
  isOriginalSize = true,
}) {
  const defaultImage = require('../../assets/images/account/avatar.png');
  const src = imageUrl || defaultImage;

  const commonStyles = {
    width: width.toString() + 'px',
    height: height.toString() + 'px',
    borderRadius: borderRadius.toString() + '%',
    ...style,
  };

  return isOriginalSize ? (
    <img alt="avatar" src={src} style={commonStyles} />
  ) : (
    <div style={{...commonStyles, overflow: 'hidden'}}>
      <img alt="avatar" src={src} style={{maxWidth: '150px'}} />
    </div>
  );
}

Avatar.propTypes = {
  imageUrl: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  borderRadius: PropTypes.number,
  style: PropTypes.object,
  isOriginalSize: PropTypes.bool,
};
